/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { RechtsgrundEntryMeta } from './rechtsgrundEntryMeta';
import { CapiCodeTextEntryMeta } from './capiCodeTextEntryMeta';
import { EigentumanteilMasterIdMeta } from './eigentumanteilMasterIdMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { BerechtigtesGrundstueckMeta } from './berechtigtesGrundstueckMeta';
import { EigentuemerEntryMeta } from './eigentuemerEntryMeta';
import { EigentumanteilVersionDetailEntryMeta } from './eigentumanteilVersionDetailEntryMeta';


export interface EigentumanteilMasterDetailEntryMeta { 
    berechtigtePersonen?: Array<EigentuemerEntryMeta>;
    mBerechtigtePersonen?: FieldMetaData;
    id?: EigentumanteilMasterIdMeta;
    mId?: FieldMetaData;
    isSubjektivDinglich?: boolean;
    mIsSubjektivDinglich?: FieldMetaData;
    eigentumanteilArt?: EigentumanteilMasterDetailEntryMeta.EigentumanteilArtEnum;
    mEigentumanteilArt?: FieldMetaData;
    belastetesGrundstueck?: GrundstueckListEntryMeta;
    mBelastetesGrundstueck?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    berechtigtesGrundstueck?: BerechtigtesGrundstueckMeta;
    mBerechtigtesGrundstueck?: FieldMetaData;
    versions?: Array<EigentumanteilVersionDetailEntryMeta>;
    mVersions?: FieldMetaData;
    rechtsgruende?: Array<RechtsgrundEntryMeta>;
    mRechtsgruende?: FieldMetaData;
    externeHinweise?: Array<CapiCodeTextEntryMeta>;
    mExterneHinweise?: FieldMetaData;
}
export namespace EigentumanteilMasterDetailEntryMeta {
    export type EigentumanteilArtEnum = 'GRUNDSTUECK' | 'PERSON' | 'HERRENLOS';
    export const EigentumanteilArtEnum = {
        GRUNDSTUECK: 'GRUNDSTUECK' as EigentumanteilArtEnum,
        PERSON: 'PERSON' as EigentumanteilArtEnum,
        HERRENLOS: 'HERRENLOS' as EigentumanteilArtEnum
    };
}


